import { isArray } from 'util';
import { sortByString, mapCollection } from '../../utils/collection.utils';
import { ComplementType } from '../complement-type';

export class ComplementTypeBuilder {

  static fromJson(json): ComplementType {
    return (json) ? new ComplementType(
      json.hash,
      json.name,
    ) : null;
  }

  static fromJsonList(list): ComplementType[] {
    return (isArray(list)) ? sortByString('name', mapCollection(ComplementTypeBuilder.fromJson, list)) : [];
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/core/models/builders/complement-type-builder.ts